import { useCallback } from 'react';
import { assignRef } from '../utils/assign-ref/assign-ref.js';
function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
}
function useMergedRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useCallback(mergeRefs.apply(void 0, refs), refs);
}
export { mergeRefs, useMergedRef };